import React, { useRef } from 'react'

import { ConfirmDialog } from '@mangovoice/mango-ui'

import { useDevicesI18n } from '../i18n'

interface DeviceDeleteDialogProps {
  isOpen: boolean
  onClose: () => void
  stationLabel: string
  onConfirm: () => void
  isDeleting: boolean
}

export const DeviceDeleteDialog = React.memo<DeviceDeleteDialogProps>(
  ({ isOpen, onClose, stationLabel, onConfirm, isDeleting }) => {
    const { text } = useDevicesI18n()
    const lastLabelRef = useRef(stationLabel)
    if (stationLabel) {
      lastLabelRef.current = stationLabel
    }
    const displayLabel =
      stationLabel ||
      lastLabelRef.current ||
      text('devices.deleteDialog.unnamedDevice', 'Unnamed device')

    return (
      <ConfirmDialog
        open={isOpen}
        onClose={onClose}
        title={text('devices.deleteDialog.title', 'Delete device')}
        description={text(
          'devices.deleteDialog.confirmation',
          'Are you sure you want to delete "{{name}}"? This action cannot be undone.',
          { name: displayLabel },
        )}
        confirmLabel={text('devices.common.delete', 'Delete')}
        cancelLabel={text('devices.common.cancel', 'Cancel')}
        onConfirm={onConfirm}
        variant="destructive"
        isLoading={isDeleting}
      />
    )
  },
)

DeviceDeleteDialog.displayName = 'DeviceDeleteDialog'
